/**
 * @file main reducer
 */

import { combineReducers} from 'redux';
// import getCityInfo from '../lib/getCityInfo';
import {
    PannelFieldsChanged,
    DropFilterMarker,
    ResetStartFilter,
    SetCity
} from '../actions';

export default combineReducers({
    predictedWorkout(predictedWorkout = false, action) {
        switch (action.type) {
            case PannelFieldsChanged:
                switch (action.styleParamName) {
                    case 'speed':
                        return false;
                    default:
                        return action.predictedWorkout;
                }
            default:
                return predictedWorkout;
        }
    },
    sequentialColorScale(sequentialColorScale = false, action) {
        switch (action.type) {
            case PannelFieldsChanged:
                return action.sequentialColorScale;
            default:
                return sequentialColorScale;
        }
    },
    startFilterRadius(radius = 1000) {
        return radius;
    },
    startFilter(point = null, action) {
        switch (action.type) {
            case ResetStartFilter:
                return null;
            case DropFilterMarker:
                return action.point;
            case PannelFieldsChanged:
                switch (action.styleParamName) {
                    case 'speed':
                        return null
                    default:
                        return point;
                }
            default:
                return point;
        }
    },
    layerName(value = 'activities', action) {
        switch(action.type) {
            case PannelFieldsChanged:
                switch(action.styleParamName){
                    case 'average_speed':
                        return 'activities';
                    case 'speed':
                        return 'segments';
                    default:
                        return value;
                }
            case DropFilterMarker:
                return 'activities';
            default:
                return value;
        }
    },
    styleParamName(value = 'average_speed', action) {
        switch(action.type) {
            case PannelFieldsChanged:
                return action.styleParamName;
            case DropFilterMarker:
                return 'average_speed';
            default:
                return value;
        }
    },
    style(style = 'lines', action) {
        switch(action.type) {
            case PannelFieldsChanged:
                return action.style;
            default:
                return style;
        }
    },
    city(city = null, action) {
        switch(action.type) {
            case SetCity:
                return action.city
            default:
                return city
        }
    }
});



// WEBPACK FOOTER //
// ./src/reducers/index.js